<script lang="ts">
  import Button from '$lib/components/ui/button/button.svelte';
  import { t } from '$lib/i18n';
  import type { ReviewState } from '@briefmarken_katalog/types';

  const {
    readonly = false,
    state,
    reviewedBy,
    currentUserId,
    userCanReview,
    userCanEdit,
    userIsAdmin,
    userIsLoggedIn,
    onReview,
    onDelete,
    onDetails,
  } = $props<{
    readonly?: boolean;
    state: ReviewState;
    reviewedBy: string | null | undefined;
    currentUserId: string | undefined;
    userCanReview: boolean;
    userCanEdit: boolean;
    userIsAdmin: boolean;
    userIsLoggedIn: boolean;
    onReview: () => void;
    onDelete?: () => void;
    onDetails: (readonly: boolean) => void;
  }>();
</script>

<div class="flex flex-col gap-1">
  {#if readonly}
    <Button class="card-3d card-3d-anim" onclick={() => onDetails(true)}>{$t('buttons.details')}</Button>
  {:else if userIsLoggedIn && userCanReview && state === 'InReview' && reviewedBy === currentUserId}
    <Button class="card-3d card-3d-anim" onclick={onReview}>{$t('buttons.review')}</Button>
  {:else if userIsLoggedIn && userCanEdit && state !== 'InReview'}
    <Button class="card-3d card-3d-anim" onclick={() => onDetails(false)}>{$t('buttons.edit')}</Button>
    {#if onDelete}<Button class="card-3d card-3d-anim" variant="destructive" onclick={onDelete}>{$t('buttons.delete')}</Button>{/if}
  {:else if userIsLoggedIn}
    <Button class="card-3d card-3d-anim" onclick={() => onDetails(true)}>{$t('buttons.details')}</Button>
    {#if userIsAdmin && state !== 'InReview' && onDelete}
      <Button class="card-3d card-3d-anim" variant="destructive" onclick={onDelete}>{$t('buttons.delete')}</Button>
    {/if}
  {/if}
</div>
